import { render } from "./Hairline.vue?vue&type=template&id=35430408"
const script = {}

import "./Hairline.vue?vue&type=style&index=0&id=35430408&lang=scss"
script.render = render

export default script